import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const APPLE_STORE_URL = 'itms-apps://itunes.apple.com/app/id6733228175';
const GOOGLE_PLAY_URL = 'market://details?id=com.weartwice.weartwice';

function Download() {
  const navigate = useNavigate();

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      window.location.href = GOOGLE_PLAY_URL;
    } else if (/iPad|iPhone|iPod/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      window.location.href = APPLE_STORE_URL;
    } else {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  return null;
}

export default Download;
